import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
const SECTIONS = [{
  title: 'Acceptance of Terms',
  body: 'By accessing and using the Maisha Medical Center website and services, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please refrain from using our services.'
}, {
  title: 'Medical Services Disclaimer',
  body: 'The information provided on this website is for general informational and educational purposes only and does not constitute medical advice. It is not a substitute for professional diagnosis, consultation, or treatment by a qualified healthcare provider.'
}, {
  title: 'Appointments and Bookings',
  body: 'Appointment requests submitted through our website or WhatsApp are subject to confirmation by our reception team. We will make reasonable efforts to accommodate your preferred date and time, but availability is not guaranteed until confirmed.'
}, {
  title: 'Patient Responsibilities',
  body: 'Patients are responsible for providing accurate and complete personal and medical information, arriving on time for scheduled appointments, and following the medical advice and treatment plans provided by our healthcare professionals.'
}, {
  title: 'Payments and Medical Aid',
  body: 'Fees for services are payable as advised by our reception. Where medical aid is used, it remains your responsibility to ensure your scheme covers the services rendered. Any shortfall not covered by your medical aid is payable by you.'
}, {
  title: 'Cancellations',
  body: 'We kindly ask that you notify us in advance if you are unable to attend a scheduled appointment, so we can offer the slot to other patients. Repeated missed appointments without notice may affect future bookings.'
}, {
  title: 'Limitation of Liability',
  body: 'While we strive to provide accurate information and high-quality care, Maisha Medical Center shall not be held liable for any indirect or consequential loss arising from the use of this website or reliance on its content.'
}, {
  title: 'Changes to These Terms',
  body: 'We may update these Terms of Service from time to time. Continued use of our services after any changes constitutes acceptance of the revised terms. For questions, contact us at bookings@maishahealth.co.bw or +267 6540244.'
}];
export function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-brand-light pb-20" data-id="element-976" data-mp="kbq89wx8lm36">
      <div className="bg-brand-navy py-20 relative overflow-hidden" data-id="element-977" data-mp="5lskvj74t0f1">
        <div className="absolute -top-[30%] -right-[10%] w-[60%] h-[140%] rounded-full bg-brand-red/5 blur-[120px] pointer-events-none" data-id="element-978" data-mp="5nlnmnemj0hr" />
        <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-979" data-mp="3sqqjzgc66i4q">
          <nav aria-label="Breadcrumb" className="flex items-center justify-center gap-2 text-sm text-slate-300 mb-6" data-id="element-980" data-mp="1jxj6dlagl0q">
            <Link to="/" className="hover:text-brand-gold transition-colors" data-id="element-981" data-mp="3e4b8wxnbe41x">
              Home
            </Link>
            <ChevronRight className="w-4 h-4" data-id="element-982" data-mp="396t2bdwrs0x3" />
            <span className="text-brand-gold" data-id="element-983" data-mp="3n4pxq6zhm1a6">Terms of Service</span>
          </nav>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-984" data-mp="3j34hcbnqv4v8">
            Terms of Service
          </h1>
          <p className="text-slate-300" data-id="element-985" data-mp="vyibvti8fkt">Last updated: June 2026</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-id="element-986" data-mp="3s2j5h4gfv3ck">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-8 md:p-12 space-y-10" data-id="element-987" data-mp="amt3sxyxfb57">
          {SECTIONS.map(section => <section key={section.title} data-id="element-988" data-mp="5ohvwss6zapm">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-brand-navy mb-3" data-id="element-989" data-mp="jnr16xev0ket">
                {section.title}
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-990" data-mp="epz6xwqqsm7g">{section.body}</p>
            </section>)}
        </div>
      </div>
    </div>;
}